import { render, staticRenderFns } from "./StudentGym.vue?vue&type=template&id=d380ba78&"
import script from "./StudentGym.js?vue&type=script&lang=js&"
export * from "./StudentGym.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports